import cn from "classnames";

import React from "react";

import { Typography } from "@mui/material";

interface FormItemProps {
  label: string;
  children: React.ReactNode;
  labelClass?: string;
}

const FormItem = ({ label, children, labelClass }: FormItemProps) => {
  return (
    <div className={cn("flex items-center min-h-[36px] mb-[16px]")}>
      <div className={cn("mr-[10px] flex items-center", labelClass)}>
        <Typography variant="body2" className="break-all">
          {label}
        </Typography>
      </div>
      <div className="flex flex-1">{children}</div>
    </div>
  );
};

export default React.memo(FormItem);
